import HeroEditSecondaryButton from './HeroEditSecondaryButton';

export default HeroEditSecondaryButton;
